import { PanelSectionTypeEnum } from '@app/shared/utils';
import { createAction, props } from '@ngrx/store';
import { DailyAllowanceStep } from '../../daily-allowance-step';
/**
 * Action dispatched to start a daily allowance flow
 * It resets daily allowance store data and consultation store data
 */
export const startDailyAllowance = createAction(
  '[Daily Allowance] Start',
  props<{ withIdentification: true; persist?: boolean } | { withIdentification: false; isNewPet?: boolean; persist?: boolean }>(),
);
/**
 * Set current step
 */
export const setDailyAllowanceStep = createAction('[Daily Allowance] Set Step', props<{ value: DailyAllowanceStep }>());
/**
 * Set steps
 */
export const setDailyAllowanceSteps = createAction('[Daily Allowance] Set Steps', props<{ value: DailyAllowanceStep[] }>());
/**
 * Navigate back to step from panel from another module (allowance) during consultation
 */
export const navigateBackToStep = createAction('[Daily Allowance] Navigate back to step', props<{ value: PanelSectionTypeEnum }>());
/**
 * Reset daily allowance store
 */
export const resetDailyAllowanceState = createAction('[Daily Allowance] Reset State');
